<script setup lang="ts">
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { Info } from 'lucide-vue-next'

/**
 * The ⓘ beside an Insights label: the ticket's Definitions table, in plain words, one
 * tooltip per metric so the page explains itself without a legend.
 */
defineProps<{
    title: string
    text: string
}>()
</script>

<template>
    <Tooltip>
        <TooltipTrigger as-child>
            <button
                type="button"
                class="inline-flex shrink-0 cursor-help items-center text-muted-foreground hover:text-foreground"
                :aria-label="title"
            >
                <Info class="size-3.5" />
            </button>
        </TooltipTrigger>
        <TooltipContent side="top" class="max-w-xs text-xs leading-relaxed normal-case font-normal tracking-normal">
            <span class="mb-0.5 block font-semibold">{{ title }}</span>
            {{ text }}
        </TooltipContent>
    </Tooltip>
</template>
